var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hospital"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 4.66667V7.33333M9.33344 14V12C9.33344 11.6464 9.19295 11.3072 8.94288 11.0572C8.69282 10.8071 8.35365 10.6667 8 10.6667C7.64635 10.6667 7.30718 10.8071 7.05712 11.0572C6.80705 11.3072 6.66656 11.6464 6.66656 12V14M9.33344 6H6.66656M12.0003 7.33333H13.3338C13.6874 7.33333 14.0266 7.47381 14.2766 7.72386C14.5267 7.97391 14.6672 8.31304 14.6672 8.66667V12.6667C14.6672 13.0203 14.5267 13.3594 14.2766 13.6095C14.0266 13.8595 13.6874 14 13.3338 14H2.66624C2.31259 14 1.97342 13.8595 1.72336 13.6095C1.47329 13.3594 1.3328 13.0203 1.3328 12.6667V6.66667C1.3328 6.31304 1.47329 5.97391 1.72336 5.72386C1.97342 5.47381 2.31259 5.33333 2.66624 5.33333H3.99968M12.0003 14V3.33333C12.0003 2.97971 11.8598 2.64057 11.6098 2.39052C11.3597 2.14048 11.0205 2 10.6669 2H5.33312C4.97947 2 4.6403 2.14048 4.39024 2.39052C4.14017 2.64057 3.99968 2.97971 3.99968 3.33333V14",
    stroke: "#1B8C5A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.a2c9534d6268365938c2b98f758af779.svg";
export { ForwardRef as ReactComponent };